import { lazysizes } from "lazysizes";
import { gsap } from "gsap";

gsap.to('.test', {opacity: 10})


